const PSEvents = require('PSEvents');
const PSConfig = require('PSConfig');

cc.Class({
    extends: cc.Component,

    properties: {
        activeForProviders: true,
        providers: [cc.String]
    },

    start () {
        if (!this.providers.length) {
            return;
        }
        const PSGames = window.PSGames;
        if (PSGames && PSGames.launchParams && PSGames.launchParams.provider) {
            const provider = PSGames.launchParams && PSGames.launchParams.provider;

            this.node.active = this.activeForProviders === this.providers.includes(provider);
        } else {
            PSEvents.onEngineInitialized(() => {
                const { provider } = PSConfig.get();

                this.node.active = this.activeForProviders === this.providers.includes(provider);
            });
        }
    }

});
